
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IAutomationAppComponent } from "../../types";
import { AiOutlinePercentage } from "react-icons/ai";
import {SideviewPanel} from "./SideviewPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: AiOutlinePercentage,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    SideViewPanel: SideviewPanel,
    createConfig:     {
        group: "Utilities",
        name: "Shows the COP of a heating pump",
        description: "HeatingPumpCOP",
        panel: OverviewPanel,
    },
}